import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {SolutionService} from '../../../Services/solution.service';

@Component({
  selector: 'app-solution-archive',
  templateUrl: './solution-archive.component.html',
  styleUrls: ['./solution-archive.component.scss']
})
export class SolutionArchiveComponent implements OnInit {

  public grid: Grid;
  public solutionId;
  public solutionName;
  @ViewChild('reAddModal', {static: false}) reAddModal;

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private broadcastService: BroadcastService,
    private solutionService: SolutionService
  ) { }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'admin.general_items.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,

        },
        <TextColumn>{
          name: 'admin.solution.overview.active_subjects',
          prop: 'serviceSubjects',
          type: TextColumn.type,
          sortable: true,
          translate: true,
          valueFormatter: function (serviceSubjects) {
            const items = [];
            serviceSubjects.forEach(serviceSubject => {
              items.push(serviceSubject.name);
            });
            return items.join(', ');
          }
        },
        <TextColumn>{
          name: 'admin.general_items.status',
          prop: 'status',
          type: TextColumn.type,
          sortable: true,
          translate: true,
          valueFormatter: row => row ? this.translateService.instant('global.active') : this.translateService.instant('global.inactive')
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus fa-lg',
              tooltip: 'global.readd',
              onclick: row => {
                this.solutionId = row.id;
                this.solutionName = row.name.bold();
                this.reAddModal.show();
              },
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.solutionService,
      rememberURL: this.router.url,
      method: 'getArchiveSolutions',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
    };
  }

  goToOverview() {
    this.router.navigateByUrl('back-office/service/solution/overview');
  }

  reAddSolution() {
    this.solutionService.readdSolution(this.solutionId).subscribe((res) => {
      this.reAddModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getArchiveSolutions');
    });
  }
}
